<template>
  <ul class="form-item-list">
    <li><h3><b>최근 3개월 이내에</b> 의사로부터 진찰 또는 검사(건강검진 포함)를 통하여 다음과 같은 의료행위를 받은 사실이 있습니까?</h3></li>
    <li>
      <p>1. 질병확정진단</p>
      <p>2. <b>질병의심소견</b><span class="blue">*</span></p>
      <p>3. 치료</p>
      <p>4. 입원</p>       
      <p>5. 수술(제왕절개포함)</p>
      <p>6. <b>투약</b><span class="blue">*</span></p>
    </li>
    <li class="annotation">
      <p>※ <b>질병의심소견</b>이란 의사로부터 진단서 또는 소견서를 발급받은 경우를 말합니다.</p>
      <p>※ <b>투약</b>이란 의사가 환자에게 약을 처방하는 행위를 말하는 것으로 실제로 약을 구입하지 않았어도 기재해야합니다.</p>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>

    <li v-if="yes">
      <Detail
        @update-detail="updateDetail"
        @update-detail-treatment="updateDetailTreatment"
        @add-detail="addDetail"
      />
    </li>
  </ul>
</template>

<script>
import { Checkbox } from 'element-ui';
import Detail from './Detail';

export default {
  name: 'Examination',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    Detail
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      details: [],
    }
  },
  mounted() {
    this.addDetail(0);
  },
  methods: {
    addDetail(index) {
      this.updateDetail({
        '병명': '',
        '완치여부': '',
        '재발여부': '',
        '치료기간': {
          '시작': '',
          '끝': '',
          '일수': '',
          '통입원': '',
        },
        '치료내용': '',
        '치료병원': '',
      }, index);

      this.$emit('update', { type: 'detail', value: this.details });
    },
    isEmptyDetailData() {
      return this.details.map(detail => {
        let isEmptyData = detail.value === '';

        if (detail.label === '치료기간') {
          isEmptyData = detail.value.every(d => d.value === '');
        }

        return isEmptyData;
      }).every(data => {
        console.log(data)
        return true;
      })
    },
    updateDetailTreatment(index, key, detail) {
      this.details[index]['치료기간'][key] = detail.value;
    },
    updateDetail(detail, index) {
      if (!this.details[index]) {
        this.details[index] = {};
      }

      if (detail.label) {
        this.details[index][detail.label] = detail.value;
        return;
      }

      this.details[index] = detail;
    },
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;

      if (type === 'yes') {
        console.log(this.isEmptyDetailData())
      }

      this.$emit('update', { type: 'answer', value: type });
    },
  }
}
</script>

<style lang="scss">
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
}
</style>